/**
 * i18next configuration for frontend
 * Supports Uzbek (uz), Russian (ru), and English (en) languages
 * Default language: Uzbek (uz)
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import uz from './locales/uz.json';
import ru from './locales/ru.json';
import en from './locales/en.json';

// Get language from URL first, then localStorage, then default
const getInitialLanguage = (): 'uz' | 'ru' | 'en' => {
  // Check URL first
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const urlLang = pathParts[0];
  
  if (urlLang && ['uz', 'ru', 'en'].includes(urlLang)) {
    return urlLang as 'uz' | 'ru' | 'en';
  }
  
  // Then check localStorage
  const stored = localStorage.getItem('language');
  
  if (stored && ['uz', 'ru', 'en'].includes(stored)) {
    return stored as 'uz' | 'ru' | 'en';
  }
  
  // Default to Uzbek
  return 'uz';
};

// Initialize i18next
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      uz: { translation: uz },
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: getInitialLanguage(), // Get language from URL or localStorage
    fallbackLng: 'en', // Fallback to English if translation not found
    supportedLngs: ['uz', 'ru', 'en'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for now
    },
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
